import { jsPDF } from "jspdf";
import axios from 'axios';
import autoTable from 'jspdf-autotable';

const API_URL = process.env.REACT_APP_API_URL;

export const generatePDF = async (customerName, customerPrename, customerAddress, customerPostCode, customerTown, customerNumber, actionDate, actionDateTo, invoiceDate, invoiceNumber, paymentMethod, tax, isPaid, paymentDeadlineDays = 7) => {
    try {
        const res = await axios({
            method: 'GET',
            url: `${API_URL}/users/me`,
            withCredentials: true
        });

        const userData = res.data.data;
        const imgPath = userData.photo; 
        const imgResponse = await axios.get(imgPath, { responseType: 'arraybuffer' });
        const imgBase64 = `data:image/jpeg;base64,${btoa(
            new Uint8Array(imgResponse.data).reduce((data, byte) => data + String.fromCharCode(byte), '')
        )}`;

        const doc = new jsPDF();

        let ownerLine = `Inh. ${userData.prename} ${userData.name}`;
        if (userData.partners && userData.partners.length > 0) {
            const partnerNames = userData.partners
                .map(p => `${p.prename} ${p.name}`)
                .join(' & ');
            ownerLine = `Inh. ${userData.prename} ${userData.name} & ${partnerNames}`;
        }

        // Kopfzeile mit Unternehmensinfos
        const kopfzeile = `${userData.companyName} - ${userData.address} - ${userData.town}`;
        doc.setFontSize(6);
        doc.text(kopfzeile, 20, 40);
        doc.line(20, 41, 20 + doc.getTextWidth(kopfzeile), 41);

        // Rechte Spalte: Absender-Details
        const rightAlignX = 190;
        doc.setFontSize(8);
        doc.setFont('Helvetica', 'bold');
        doc.text(userData.companyName, rightAlignX - doc.getTextWidth(userData.companyName), 30);
        
        doc.setFont('Helvetica', 'normal');
        doc.text(ownerLine, rightAlignX - doc.getTextWidth(ownerLine), 34);

        doc.text(userData.address, rightAlignX - doc.getTextWidth(userData.address), 38);
        doc.text(`${userData.postCode} ${userData.town}`, rightAlignX - doc.getTextWidth(`${userData.postCode} ${userData.town}`), 42);
        doc.text(userData.phoneNumber, rightAlignX - doc.getTextWidth(userData.phoneNumber), 50);
        doc.text(userData.email, rightAlignX - doc.getTextWidth(userData.email), 54);
        doc.text(userData.website, rightAlignX - doc.getTextWidth(userData.website), 58);

        // Logo
        doc.addImage(imgBase64, 'JPEG', 20, 5, 40, 25);

        // Kundeninformationen
        doc.setFontSize(8);
        doc.text(`${customerPrename} ${customerName}`, 20, 50);
        doc.text(customerAddress, 20, 54);
        doc.text(`${customerPostCode} ${customerTown}`, 20, 58);

        // Rechnungstitel
        doc.setFontSize(12);
        doc.setFont('Helvetica', 'bold');
        doc.text("Rechnung", 20, 70);

        // Rechnungsdetails
        doc.setFontSize(9);
        doc.text("Rechnungsnummer: ", 20, 74);
        doc.text(invoiceNumber, 56, 74);
        doc.text("Kundennummer: ", 20, 78);
        doc.text(customerNumber, 56, 78);
        const formattedActionDate = actionDate instanceof Date
                ? `${actionDate.getDate().toString().padStart(2, '0')}.${(actionDate.getMonth() + 1).toString().padStart(2, '0')}.${actionDate.getFullYear()}`
                : 'Unbekanntes Datum';
        const formattedActionDateTo = actionDateTo instanceof Date
                ? `${actionDateTo.getDate().toString().padStart(2, '0')}.${(actionDateTo.getMonth() + 1).toString().padStart(2, '0')}.${actionDateTo.getFullYear()}`
                : 'Unbekanntes Datum';
        const formattedInvoiceDate = invoiceDate instanceof Date
                ? `${invoiceDate.getDate().toString().padStart(2, '0')}.${(invoiceDate.getMonth() + 1).toString().padStart(2, '0')}.${invoiceDate.getFullYear()}`
                : 'Unbekanntes Datum';
        if(actionDateTo === undefined || actionDateTo === null) {
            doc.text("Leistungsdatum: ", 140, 74);
            doc.text(formattedActionDate, 173, 74);
            doc.text("Rechnungsdatum: ", 140, 78);
            doc.text(formattedInvoiceDate, 173, 78);
        } else {
            doc.text("Leistungszeitraum: ", 120, 74);
            doc.text(`${formattedActionDate} - ${formattedActionDateTo}`, 153, 74);
            doc.text("Rechnungsdatum: ", 120, 78);
            doc.text(formattedInvoiceDate, 153, 78);
        }

        // Tabellendaten sammeln
        const tableRows = document.querySelectorAll("table tr");
        const columns = ["Pos.", "Leistung", "Einzelpreis", "Anzahl", "Gesamt"];
        const rows = [];
        let nettoSum = 0;
        let bruttoSum = 0;

        const validTax = parseFloat(tax) || 0;

        tableRows.forEach((row, index) => {
            const cells = row.querySelectorAll("td");
            if (cells.length < 4) {
                console.warn(`Zeile ${index + 1} hat weniger als 4 Zellen und wird übersprungen.`);
                return;
            }

            const anzahl = parseFloat(cells[4].textContent.trim());
            const einzelpreis = parseFloat(cells[3].textContent.trim());
            const total = einzelpreis * anzahl;

            nettoSum += total;
            bruttoSum += total + (total * validTax / 100);

            rows.push([
                rows.length + 1, 
                cells[2].textContent.trim(),
                `${einzelpreis.toFixed(2)} €`, 
                anzahl, 
                `${total.toFixed(2)} €`
            ]);
        });

        autoTable(doc, {
            startY: 85,
            head: [columns],
            body: rows.length > 0 ? rows : [["-", "Keine Daten", "-", "-"]],
            theme: 'striped',
            styles: { fontSize: 8 },
            headStyles: {
                fillColor: [230, 230, 230],
                textColor: [0, 0, 0],
            },
            margin: { left: 20, right: 20 },
            columnStyles: {
                0: { halign: 'left' },
                1: { halign: 'left' },
                2: { halign: 'left' },
                3: { halign: 'left' },
                4: { halign: 'left' }, 
                5: { halign: 'left' }, 
            },
        });

        const finalY = doc.lastAutoTable.finalY || 85;

        doc.setFontSize(8);
        doc.text(`Nettobetrag: ${nettoSum.toFixed(2)} €`, rightAlignX - doc.getTextWidth(`Nettobetrag: ${nettoSum.toFixed(2)} €`), finalY + 10);
        doc.text(`Bruttobetrag: ${bruttoSum.toFixed(2)} €`, rightAlignX - doc.getTextWidth(`Bruttobetrag: ${bruttoSum.toFixed(2)} €`), finalY + 14);

        // Zahlungsmethode
        const paymentMethodY = finalY + 20;
        doc.setFontSize(8);
        doc.setFont('Helvetica', 'bold');
        if(validTax === 0) doc.text('Gemäß §19 UStG wird keine Umsatzsteuer berechnet.', 20, paymentMethodY + 4);
        doc.setFont('Helvetica', 'normal');
        if(isPaid) {
            if(paymentMethod === 'Unbekannte Zahlungsmethode' || paymentMethod === '' || paymentMethod === undefined) {
                doc.text(`Der Betrag wurde beglichen.`, 20, paymentMethodY + 8);
            } else {
                doc.text(`Der Betrag wurde in Form von ${paymentMethod} beglichen.`, 20, paymentMethodY + 8);
            }
        } else if (paymentDeadlineDays && paymentDeadlineDays > 0) {
            doc.text(`Der Betrag ist innerhalb von ${paymentDeadlineDays} Tagen auf das unten angegebene Konto zu überweisen.`, 20, paymentMethodY + 8);
            doc.text(`Bitte geben Sie die Rechnungsnummer als Verwendungszweck an.`, 20, paymentMethodY + 12);
        } else {
            doc.text(`Bitte überweisen Sie den Betrag auf das unten angegebene Konto.`, 20, paymentMethodY + 8);
            doc.text(`Bitte geben Sie die Rechnungsnummer als Verwendungszweck an.`, 20, paymentMethodY + 12);
        }

        // Fußzeile mit Bankdaten
        const footerY = 254;
        doc.line(20, 250, 190, 250);
        doc.setFontSize(7);
        doc.text(userData.companyName, 25, footerY);
        doc.text(ownerLine, 25, footerY + 4); // AUCH HIER DIE PARTNER
        doc.text(userData.address, 25, footerY + 8);
        doc.text(`${userData.postCode} ${userData.town}`, 25, footerY + 12);

        // Mittlere Spalte Fußzeile
        doc.text(`Mobil: ${userData.phoneNumber}`, 85, footerY);
        doc.text(userData.email, 85, footerY + 4);
        doc.text(userData.website, 85, footerY + 8);

        // Rechte Spalte Fußzeile (Bankdaten)
        doc.text(userData.bank, rightAlignX - doc.getTextWidth(userData.bank), footerY);
        doc.text(`BIC: ${userData.bic}`, rightAlignX - doc.getTextWidth(`BIC: ${userData.bic}`), footerY + 4);
        doc.text(`IBAN: ${userData.iban}`, rightAlignX - doc.getTextWidth(`IBAN: ${userData.iban}`), footerY + 8);
        doc.text(`Steuernummer: ${userData.taxNumber}`, rightAlignX - doc.getTextWidth(`Steuernummer: ${userData.taxNumber}`), footerY + 12);

        // PDF speichern
        doc.save(`Rechnung-${invoiceNumber}.pdf`);
    } catch (error) {
        console.error("Fehler beim Generieren der Rechnung:", error.response?.data?.message || error.message);
    }
};